/**
 * @generated SignedSource<<fdadb5735e4bcf2113cec1abffd5a4c0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompanionModeNavbar_viewer$data = {
  readonly account: {
    readonly image: string;
    readonly name: string;
  };
  readonly unreadBeacons: ReadonlyArray<string>;
  readonly user: {
    readonly id: string;
  };
  readonly " $fragmentSpreads": FragmentRefs<"MeetingsPanel_viewer" | "UpgradeLink_viewer" | "utils_useShouldShowUpgradeLink_viewer">;
  readonly " $fragmentType": "CompanionModeNavbar_viewer";
};
export type CompanionModeNavbar_viewer$key = {
  readonly " $data"?: CompanionModeNavbar_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CompanionModeNavbar_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CompanionModeNavbar_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unreadBeacons",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": "image",
          "args": null,
          "kind": "ScalarField",
          "name": "logo",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "utils_useShouldShowUpgradeLink_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UpgradeLink_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MeetingsPanel_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "86a89acb1ff6c324414e41fb7e31f8c5";

export default node;
